import React from 'react';
import { useNavigate } from 'react-router-dom';

function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-[900px] mx-auto px-4 md:px-8 py-12">
      <button
        onClick={() => navigate('/')}
        className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors mb-8"
      >
        <span className="material-symbols-outlined">arrow_back</span>
        <span>Back to Marketplace</span>
      </button>

      <div className="bg-surface-dark border border-white/5 rounded-xl p-8 animate-fadeIn">
        <h1 className="text-4xl font-bold text-white mb-6">Privacy Policy</h1>
        <p className="text-gray-400 mb-8">Last Updated: January 2026</p>

        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Information We Collect</h2>
            <p className="leading-relaxed mb-4">
              We collect information necessary to process your purchases and provide our services:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Payment information (processed securely through Stripe)</li>
              <li>Email address for purchase confirmations</li>
              <li>Download codes and purchase history</li>
              <li>Basic usage analytics to improve our service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. How We Use Your Information</h2>
            <p className="leading-relaxed mb-4">Your information is used to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Process and fulfill your orders</li>
              <li>Send purchase confirmations and download information</li>
              <li>Provide customer support</li>
              <li>Prevent fraud and ensure security</li>
              <li>Improve our products and services</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Payment Security</h2>
            <p className="leading-relaxed">
              All payment processing is handled by Stripe, a PCI-compliant payment processor. We do not store your
              credit card information on our servers. Payment data is encrypted and transmitted securely using industry-standard SSL technology.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Data Sharing</h2>
            <p className="leading-relaxed mb-4">
              We do not sell, trade, or rent your personal information to third parties. We may share information with:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Payment processors (Stripe) to complete transactions</li>
              <li>Service providers who assist in operating our website</li>
              <li>Law enforcement when required by law</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Cookies and Tracking</h2>
            <p className="leading-relaxed">
              We use cookies and similar tracking technologies to enhance your browsing experience and analyze site traffic.
              You can control cookie preferences through your browser settings.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Data Retention</h2>
            <p className="leading-relaxed">
              We retain your purchase information for as long as necessary to provide services and comply with legal obligations.
              Download codes remain active indefinitely for purchased products.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Your Rights</h2>
            <p className="leading-relaxed mb-4">You have the right to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Access your personal data</li>
              <li>Request corrections to your data</li>
              <li>Request deletion of your data (subject to legal requirements)</li>
              <li>Opt-out of marketing communications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Children's Privacy</h2>
            <p className="leading-relaxed">
              Our services are not intended for individuals under the age of 18. We do not knowingly collect personal
              information from children.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Changes to Privacy Policy</h2>
            <p className="leading-relaxed">
              We may update this privacy policy from time to time. Changes will be posted on this page with an updated
              revision date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Contact Us</h2>
            <p className="leading-relaxed">
              If you have questions about this Privacy Policy or how we handle your data, please contact us through
              our Discord server.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
